/* eslint-disable max-len, camelcase */
import router from '@/modules/FPKG-20000-Util/vueRouter'; // lists 使用的router
import $store from '@/modules/FPKG-50000-Vuex/index'; // lists 與axios溝通
import $http from '@/modules/FPKG-20000-Util/prototypes/axios'; // 後端溝通
import ExpError from '@/modules/FPKG-20000-Util/library/ExpError';
import errorCode from '../../errorCode'; // 進行後端error code提示


import {
  INFO, LISTS, CREATE, MODIFY, DO_MODIFY, DELETE,
} from './declare';

export {
  INFO, LISTS, CREATE, MODIFY, DO_MODIFY, DELETE,
};

/**
 * 發出請求，向後端送資料 並回傳非同步資料
 */
const Getter = {
  async create(params: CREATE.request): Promise<CREATE.AxiosResponse> {
    return $http.post(CREATE.API, params).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },

  async lists(userParams?: LISTS.request): Promise<LISTS.response> {
    const { currentRoute } = router;
    /** 取得搜尋參數: 從 query, params, user設定 進行整理 */
    const params = {
      ...currentRoute.query, ...currentRoute.params, ...userParams,
    };

    return $http.get(LISTS.API, { params })
      .then((d) => {
        if (d.data.code === 0) {
          const result = d.data.response;
          $store.dispatch('getList', result);
          return result;
        }
        throw errorCode(d.data);
      });
  },

  async info(params: INFO.request): Promise<INFO.AxiosResponse> {
    return $http.get(INFO.API, { params }).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },


  async modify(params: MODIFY.request): Promise<MODIFY.AxiosResponse> {
    return $http.get(MODIFY.API, { params }).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },

  async doModify(params: DO_MODIFY.request): Promise<DO_MODIFY.AxiosResponse> {
    return $http.put(DO_MODIFY.API, params).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },

  async delete(params: DELETE.request): Promise<DELETE.AxiosResponse> {
    return $http.delete(DELETE.API, { params }).then((d) => {
      if (d.data.code !== 0) { throw errorCode(d.data); }
      return d;
    });
  },
};

export default Getter;
